const actions = {
    CREATE_INSTRUCTION_REQUEST: 'CREATE_INSTRUCTION_REQUEST',
    CREATE_INSTRUCTION_SUCCESS: 'CREATE_INSTRUCTION_SUCCESS',
    CREATE_INSTRUCTION_ERROR: 'CREATE_INSTRUCTION_ERROR',
    INIT_INSTRUCTION_REQUEST: 'INIT_INSTRUCTION_REQUEST',
    INIT_INSTRUCTION_SUCCESS: 'INIT_INSTRUCTION_SUCCESS',
    INIT_INSTRUCTION_ERROR: 'CREATE_INSTRUCTION_ERROR',
    READ_INSTRUCTIONS_REQUEST: 'READ_INSTRUCTIONS_REQUEST',
    READ_INSTRUCTIONS_SUCCESS: 'READ_INSTRUCTIONS_SUCCESS',
    READ_INSTRUCTIONS_ERROR: 'READ_INSTRUCTIONS_ERROR',
    READ_INSTRUCTION_REQUEST: 'READ_INSTRUCTION_REQUEST',
    READ_INSTRUCTION_SUCCESS: 'READ_INSTRUCTION_SUCCESS',
    READ_INSTRUCTION_ERROR: 'READ_INSTRUCTION_ERROR',
    UPDATE_INSTRUCTION_REQUEST: 'UPDATE_INSTRUCTION_REQUEST',
    UPDATE_INSTRUCTION_SUCCESS: 'UPDATE_INSTRUCTION_SUCCESS',
    UPDATE_INSTRUCTION_ERROR: 'UPDATE_INSTRUCTION_ERROR',
    DELETE_INSTRUCTION_REQUEST: 'DELETE_INSTRUCTION_REQUEST',
    DELETE_INSTRUCTION_SUCCESS: 'DELETE_INSTRUCTION_SUCCESS',
    DELETE_INSTRUCTION_ERROR: 'DELETE_INSTRUCTION_ERROR',
    CHANGE_INSTRUCTION: 'CHANGE_INSTRUCTION',
    CHANGE_TRANSACTION_TYPE: 'CHANGE_TRANSACTION_TYPE',
    CHANGE_TRANSACTION_STATUS: 'CHANGE_TRANSACTION_STATUS',
    CHANGE_FREQUENCY: 'CHANGE_FREQUENCY',
    CHANGE_SEND_EMAIL: 'CHANGE_SEND_EMAIL',
    CHANGE_POSTING_DATE: 'CHANGE_POSTING_DATE',
    CHANGE_BATCH_PROCESSING: 'CHANGE_BATCH_PROCESSING',
    SET_INSTRUCTION_DATE_TO: 'SET_INSTRUCTION_DATE_TO',
    UPDATE_FUNCTIONS: "UPDATE_FUNCTIONS", //

    READ_NEXT_TRANSACTION_DATE_REQUEST: 'READ_NEXT_TRANSACTION_DATE_REQUEST',
    READ_NEXT_TRANSACTION_DATE_SUCCESS: 'READ_NEXT_TRANSACTION_DATE_SUCCESS',
    READ_NEXT_TRANSACTION_DATE_ERROR: 'READ_NEXT_TRANSACTION_DATE_ERROR',

    RESET_INSTRUCTION: 'RESET_INSTRUCTION',

    createInstruction: request => ({
        type: actions.CREATE_INSTRUCTION_REQUEST,
        request,
    }),
    initInstruction: (matchParams, form) => ({
        type: actions.INIT_INSTRUCTION_REQUEST,
        matchParams,
        form,
    }),
    initInstructionSuccess: instruction => ({
        type: actions.INIT_INSTRUCTION_SUCCESS,
        instruction,
    }),
    readInstructions: request => ({
        type: actions.READ_INSTRUCTIONS_REQUEST,
        request,
    }),
    readInstruction: id => ({
        type: actions.READ_INSTRUCTION_REQUEST,
        id,
    }),
    updateInstruction: (id, request) => ({
        type: actions.UPDATE_INSTRUCTION_REQUEST,
        id,
        request,
    }),
    deleteInstruction: id => ({
        type: actions.DELETE_INSTRUCTION_REQUEST,
        id,
    }),
    changeInstruction: (request, reset = false) => ({
        type: actions.CHANGE_INSTRUCTION,
        request,
        reset,
    }),
    changeTransactionType: transactionType => ({
        type: actions.CHANGE_TRANSACTION_TYPE,
        transactionType,
    }),
    changeTransactionStatus: transactionStatus => ({
        type: actions.CHANGE_TRANSACTION_STATUS,
        transactionStatus,
    }),
    changeFrequency: frequency => ({
        type: actions.CHANGE_FREQUENCY,
        frequency,
    }),
    changeSendEmail: isOn => ({
        type: actions.CHANGE_SEND_EMAIL,
        isOn,
    }),
    changePostDating: postDating => ({
        type: actions.CHANGE_POSTING_DATE,
        postDating,
    }),
    changeBatchProcessing: batchProcessing => ({
        type: actions.CHANGE_BATCH_PROCESSING,
        batchProcessing,
    }),
    setInstructionDateTo: date => ({
        type: actions.SET_INSTRUCTION_DATE_TO,
        date,
    }),
    updateFunctions: functions => ({
        type: actions.UPDATE_FUNCTIONS,
        functions,
    }),
    getNextTransactionDate: request => ({
        type: actions.READ_NEXT_TRANSACTION_DATE_REQUEST,
        request,
    }),
    resetInstruction: () => ({
        type: actions.RESET_INSTRUCTION,
    }),
};
export default actions;
